<template>
  <div style="position: relative">
    <div class="bottom-tab-style">
      <span
        :class="{ 'bottom-style': isActive == 'T01' }"
        @click="changeTab('T01')"
        >种植业</span
      >&nbsp;
      <span
        :class="{ 'bottom-style': isActive == 'T02' }"
        @click="changeTab('T02')"
        >养殖业</span
      >
      <span
        :class="{ 'bottom-style': isActive == 'T03' }"
        @click="changeTab('T03')"
        >森林业</span
      >
    </div>
    <div
      id="myLineChart"
      style="padding-top: 20px"
      :style="{ width: '90vw', height: '280px' }"
    ></div>
  </div>
</template>

<script>
export default {
  props: ["respCurList1", "respPreList1"],
  data() {
    return {
      isActive: "T01",
      respPreList: [], //折线图去年数据
      respCurList: [], // 折线图今年数据
    };
  },
  watch: {
    respCurList1(newvalue, oldvalue) {
      this.respCurList = newvalue;
      this.drawLine();
    },
    respPreList1(newvalue, oldvalue) {
      this.respPreList = newvalue;
      this.drawLine();
    },
  },
  methods: {
    drawLine() {
      let curYear = new Date().getFullYear();
      let lastYear = curYear - 1;
      let myLineChart = this.$echarts.init(
        document.getElementById("myLineChart")
      );
      let option = {
        color: ["#31D493", "#2A8CF1"],
        legend: {
          data: [lastYear.toString() + "年", curYear.toString() + "年"],
          right: 5,
          icon: "circle",
        },

        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          data: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月",
          ],
          axisLabel: {
            //  如果这个字段不设置，echarts会根据屏宽及横坐标数据自动给出间隔
            interval: 0, // 间隔长度，可自定义（如果是时间格式，echarts会自动处理）
            rotate: 50, // 横坐标上label的倾斜度
          },
        },
        yAxis: {
          name: "(万元)",
          type: "value",
          axisLabel: {
            margin: 2,
            formatter: function (value, index) {
              if (value >= 10000 && value < 10000000) {
                value = value / 10000 + "万";
              } else if (value >= 10000000) {
                value = value / 10000000 + "千万";
              }
              return value;
            },
          },
        },
        series: [
          {
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#B4F0D8",
                },
                {
                  offset: 1,
                  color: "#FFFFFF",
                },
              ]),
            },
            name: lastYear.toString() + "年",
            data: this.respPreList,
            type: "line",
            smooth: true,
            symbolSize: 1, //设定实心点的大小
            itemStyle: {
              borderColor: "#31D493",
            },
          },
          {
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#92C4F8",
                },
                {
                  offset: 1,
                  color: "#FFFFFF",
                },
              ]),
            },
            name: curYear.toString() + "年",
            data: this.respCurList,
            type: "line",
            smooth: true,
            symbolSize: 1, //设定实心点的大小
            itemStyle: {
              borderColor: "#2A8CF1",
            },
          },
        ],
      };
      myLineChart.setOption(option);
    },
    // 获取不同险种的折线图
    changeTab(tabIndex) {
      this.isActive = tabIndex;
      this.$emit('func',{templateCode:tabIndex});
       setTimeout(() => {
      this.drawLine();
    }, 500);
    },
  },
  mounted() {

  },
};
</script>

<style scoped>
.line {
  width: 100%;
  height: 100%;
}
.bottom-style {
  border-bottom: 3px solid #31d493;
  color: #333333;
  padding-bottom: 0.05rem;
}
.bottom-tab-style {
  color: #999999;
  position: absolute;
  top: 0.1rem;
  cursor: pointer;
  z-index: 999;
  left: 0.1rem;
  font-size: 0.12rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/operationSummary/components/lineChartTwo.vue